import { setDateFormat } from '../../utils/dateFormat';
import { IDispute, IResolveDispute } from '../../utils/types';

export const color = ['#3299FF', '#00D6BB', 'Violet', 'Indigo', 'Blue'];

export const transformDataDisputeForm = (
    disputesData: any,
    empDailyResultId: number,
    employeeNo: string,
    loggedEmpNum: string
): IResolveDispute[] => {
    const disputes = disputesData.map((item: any, index: number) => {
        const dispute: IResolveDispute = {
            empDailyResultId,
            metricId: item.metric_id,
            metricName: '',
            disputedValue: item.disputed_value ? item.disputed_value.toString() : undefined,
            disputeReasonid: item.dispute_reason_id,
            proposedValue: item.proposed_value ? item.proposed_value.toString() : undefined,
            disputeComment: item.dispute_comment,
            disputeId: item.dispute_id,
            employeeNumber: loggedEmpNum + '',
            disputeDate: item.dispute_date,
            resolutionComment: item.resolution_comment,
            resolutionReasonId: item.resolution_reason_id,
            resolvedBy: item.resolved_by ??  employeeNo?.toString(),
            resolvedDate: setDateFormat(item.resolution_date),
            metricHeaderColor: color[index],
            disputeCreateBy: item.dispute_create_by,
            disputeCreateDate: setDateFormat(),
            resolutionClicked: false,
        };
        return dispute;
    });

    return disputes;
};

export const transformDataAddDisputeForm = (
    selectedMetric: any,
    employeeNo: string,
    loggedEmpNum: string
): IDispute[] => {
    const disputes = selectedMetric.map((item: any, index: number) => {
        const itemArr = item.item.split('$$');
        const dispute: IDispute = {
            empDailyResultId: itemArr[0],
            metricName: itemArr[1],
            metricLabel: itemArr[4],
            disputedValue: itemArr[3] === '--' ? undefined : itemArr[3],
            disputeReasonid: 0,
            proposedValue: undefined,
            disputeComment: '',
            disputeId: 0,
            employeeNumber: loggedEmpNum,
            disputeCreateBy: employeeNo?.toString(),
            metricId: 0,
            disputeDate: itemArr[2],
            metricHeaderColor: color[index],
            resolutionReasonId: 0,
            resolutionComment: '',
            resolutionClicked: false,
            disputeStatusId: 0,
            disputeTypeId: 1,
            resolvedBy: '',
        };
        return dispute;
    });
    return disputes;
};
